import React from 'react'
import styled from 'styled-components/macro'
import { Text, Link } from '@resultadosdigitais/tangram-components'
import { useTranslation } from 'react-i18next'
import { usePath } from '@resultadosdigitais/front-hub/react'
import RecoverPasswordSuccessImage from './recover-password-success.svg'

import Form from '../Form'

const CenterLink = styled.div`
  text-align: center;
`

const Image = styled.img`
  height: 100% !important;
  width: 100% !important;
`

function RecoverPasswordSuccess() {
  const { t } = useTranslation()
  const assetPath = usePath()

  return (
    <Form>
      <div>
        <Image src={assetPath(RecoverPasswordSuccessImage)} alt={t('RecoverPasswordSuccess.Acessibility.RecoverPasswordSuccessAlt')} />
      </div>

      <Text token={Text.tokens.TEXT_XXL_BOLD}>{t('RecoverPasswordSuccess.Title')}</Text>

      <Text token={Text.tokens.TEXT_SM_REGULAR} textColor="--color-black">
        {t('RecoverPasswordSuccess.Success')}
      </Text>

      <CenterLink>
        <Link href="https://accounts.rdstation.com.br/">{t('RecoverPasswordSuccess.Link')}</Link>
      </CenterLink>
    </Form>
  )
}

export default RecoverPasswordSuccess
